export default [
  {
    value: 'BillPaymentReversal',
    text: 'Estorno de pagamento de conta',
    id: 25,
  },
  {
    value: 'DepositByPixReturn',
    text: 'Devolução de depósito Pix',
    id: 24,
  },
  {
    value: 'ThirdPartyDepositReversal',
    text: 'Estorno de depósito para terceiros',
    id: 23,
  },
  {
    value: 'TEDReversal',
    text: 'Estorno de transferência',
    id: 22,
  },
  {
    value: 'ChargeReceipt',
    text: 'Recebimento de cobrança',
    id: 21,
  },
  {
    value: 'ChargePayment',
    text: 'Pagamento de cobrança',
    id: 20,
  },
  {
    value: 'DepositForThirdParties',
    text: 'Depósito para terceiros',
    id: 19,
  },
  {
    value: 'DepositByPix',
    text: 'Depósito via Pix',
    id: 18,
  },
  {
    value: 'PayWithPix',
    text: 'Pagamento com pix',
    id: 17,
  },
  {
    value: 'TransferPix',
    text: 'Transferência via Pix',
    id: 16,
  },
  {
    value: 'TED',
    text: 'TED',
    id: 15,
  },
  {
    value: 'TeleSena',
    text: 'Tele sena',
    id: 14,
  },
  {
    value: 'TransportCardRecharge',
    text: 'Recarga de cartão de transporte',
    id: 13,
  },
  {
    value: 'CellphoneRecharge',
    text: 'Recarga de celular',
    id: 12,
  },
  {
    value: 'BillPayment',
    text: 'Pagamento de conta',
    id: 11,
  },
  {
    value: 'PurchaseByCard',
    text: 'Compra com cartão',
    id: 10,
  },
  {
    value: 'WithdrawWithCard',
    text: 'Saque con cartão',
    id: 9,
  },
  {
    value: 'WithdrawToBankAccount',
    text: 'Retirada para conta bancária',
    id: 8,
  },
  {
    value: 'DepositByBankTransfer',
    text: 'Depósito via transferência bancária',
    id: 7,
  },
  {
    value: 'DepositByInvoice',
    text: 'Depósito via boleto bancário',
    id: 6,
  },
  {
    value: 'IdentifiedDeposit',
    text: 'Depósito bancário identificado',
    id: 5,
  },
  {
    value: 'DepositByPec',
    text: 'Depósito via PEC',
    id: 4,
  },
  {
    value: 'P2P',
    text: 'Transferência entre contas do aplicativo',
    id: 3,
  },
  {
    value: 'Store',
    text: 'Loja',
    id: 2,
  },
  {
    value: 'Unknown',
    text: 'Desconhecido',
    id: 0,
  },
];
